import { render } from "./SelectSlogan.vue?vue&type=template&id=02dda74a&scoped=true"
import script from "./SelectSlogan.vue?vue&type=script&lang=js"
export * from "./SelectSlogan.vue?vue&type=script&lang=js"

import "./SelectSlogan.vue?vue&type=style&index=0&id=02dda74a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02dda74a"]])

export default __exports__